import { APP_INITIALIZER, NgModule } from '@angular/core';
import { ConfigModule } from '@spartacus/core';
import { RecaptchaService } from '../shared/services/recaptcha.service';

export function loadRecaptcha(recaptchaService: RecaptchaService): () => Promise<void> {
  return () => recaptchaService.loadRecaptchaConfig();
}

@NgModule({
  imports: [
    ConfigModule.withConfig({
      featureModules: {
        UserRegistration: {
          module: () =>
            import('./custom-user-registration.module').then(
              (m) => m.CustomUserRegistrationModule
            ),
          cmsComponents: [
            'RegistrationPageComponent',
            'CustomerRegistrationPageComponent',
            'UserRegistrationPageComponent',
            'AccountRegistrationPageComponent',
            'EmailVerificationPageComponent',
          ],
        },
      },
    }),
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      deps: [RecaptchaService],
      useFactory: loadRecaptcha,
      multi: true,
    }
  ]
})
export class CustomUserRegistrationRootModule { }
